export default __webpack_public_path__ + "static/media/PPI-steps-015.0c353ba7.jpg";